import React from 'react';

const ResidentInfo = ({ formData, updateFormData, nextStep, prevStep }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.residentName) {
      alert('Please enter your name.');
      return;
    }
    
    if (!formData.mobileNumber) {
      alert('Please enter your mobile number.');
      return;
    }
    
    // Mobile number validation (10 digits)
    if (!/^\d{10}$/.test(formData.mobileNumber)) {
      alert('Please enter a valid 10-digit mobile number.');
      return;
    }
    
    // Email validation if provided
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      alert('Please enter a valid email address.');
      return;
    }
    
    nextStep();
  };
  
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Resident Information</h2>
      <p className="mb-4 text-gray-600">
        Block {formData.block}, Flat {formData.flatNumber}
      </p>
      
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="residentName">
            Full Name
          </label>
          <input
            id="residentName"
            name="residentName"
            type="text"
            value={formData.residentName}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="Enter your full name"
            required
          />
        </div>
        
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Resident Type
          </label>
          <div className="flex flex-wrap gap-4">
            {['owner', 'tenant', 'family'].map((type) => (
              <label key={type} className="inline-flex items-center">
                <input
                  type="radio"
                  name="residentType"
                  value={type}
                  checked={formData.residentType === type}
                  onChange={handleChange}
                  className="form-radio h-5 w-5 text-blue-600"
                />
                <span className="ml-2 text-gray-700 capitalize">{type}</span>
              </label>
            ))}
          </div>
        </div>
        
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="mobileNumber">
            Mobile Number
          </label>
          <input
            id="mobileNumber"
            name="mobileNumber"
            type="tel"
            value={formData.mobileNumber}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="10-digit mobile number"
            pattern="[0-9]{10}"
            required
          />
        </div>
        
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
            Email Address (Optional)
          </label>
          <input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder="your.email@example.com"
          />
        </div>
        
        <div className="flex justify-between">
          <button
            type="button"
            onClick={prevStep}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Back
          </button>
          
          <button
            type="submit"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default ResidentInfo;
